import { UserBasic } from "src/app/_models/user.model";

export class CompanyGroup {
    id: number;
    name: string;
    idCompany: number;
    type: CompanyGroupType;
    description: string;
    users: UserBasic[] = [];
}


export enum CompanyGroupType {
    Undefined = "undefined",
    Parking = "parking",
    Department = "department"
}